import type { RouteWithVariant } from '../../../../wac-routes';

export const jiraMigratedAnchorVariants: Extract<
	RouteWithVariant,
	{ path: 'software/jira' }
>['variant'][] = [
	'paid-lp-jsw-features',
	'paid-lp-jsw-pm',
	'paid-lp-jsw-template',
	'paid-lp-jsw-roadmaps',
	'paid-lp-jsw-tracker',
	'paid-lp-jsw-competitors',
	'paid-lp-jsw-automation',
	'paid-lp-jsw-agile',
	'paid-lp-jsw-project_collaboration',
	'paid-lp-jsw-teamwork',
	'anchor-lp-jsw-team-marketing',
	'anchor-lp-jsw-team-engineering',
	'anchor-lp-jsw-team-operations',
	'anchor-lp-jsw-team-hr',
	'anchor-lp-jsw-team-design',
	'anchor-lp-jsw-team-programmgmt',
	'anchor-lp-jsw-team-sales',
	'anchor-lp-jsw-team-legal',
];
